<ng-container *ngIf="showNavbar">

  <nav class="navbar navbar-expand-xl navbar-@@style @@if ( isTogglable ) { navbar-togglable } fixed-top" id="navbar">
    <div class="container pl-0 pr-0">
      <a class="navbar-brand align-self-baseline mr-0" href="#" aria-label="Gryf">
        <img id="logo1" class="logo" src="assets/logo_gryf_white.png" alt="" loading="lazy">
        <img style="display: none" id="logo2" class="logo" src="assets/logo_gryf_blue.png" alt="" (click)="closeNavBar()" loading="lazy">
      </a>
      <button class="navbar-toggler" type="button" (click)="collapse($event)"
              data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-icon" [class.navbar-toggler-icon--dark]="darkIcon"></span>
      </button>
      <div class="collapse navbar-collapse" [class.show]="collapsed" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" style="font-size: 13px" href="#" role="button" data-toggle="dropdown"
               aria-haspopup="true" [class.text-white]="!isScrolled"
               aria-expanded="false" routerLink="/about/about" (click)="closeNavBar()"
               id="about">
              O spoločnosti
            </a>
          </li>
          <li #productsDopdown="bs-dropdown" dropdown class="nav-item dropdown drop-pointer">
            <a dropdownToggle class="nav-link dropdown-toggle" id="navbarProducts"
               role="button" style="font-size: 13px" [class.text-white]="!isScrolled"
               aria-haspopup="true" aria-expanded="false"
               (click)="servicesDopdown.hide(); contactsDopdown.hide()">
              Reklamné plochy
            </a>
            <div class="bg-white dropdown-menu" [class.show]="productsDopdown.isOpen" role="menu" aria-labelledby="navbarProducts">
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px"
                 routerLink="/products/billboards"
                 (click)="closeNavBar(); scrollTop()">
                Billboardy
              </a>
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px"
                 routerLink="/products/bigboards"
                 (click)="closeNavBar(); scrollTop()">
                Bigboardy
              </a>
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px"
                 routerLink="/products/megaboards"
                 (click)="closeNavBar(); scrollTop()">
                Megaboardy
              </a>
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px"
                 routerLink="/products/others"
                 (click)="closeNavBar(); scrollTop()">
                Ostatné
              </a>
            </div>
          </li>
          <li #servicesDopdown="bs-dropdown" dropdown class="nav-item dropdown drop-pointer">
            <a dropdownToggle class="nav-link dropdown-toggle" id="navbarServices"
               role="button" style="font-size: 13px" [class.text-white]="!isScrolled"
               aria-haspopup="true" aria-expanded="false"
               (click)="productsDopdown.hide(); contactsDopdown.hide()">
              Reklamné predmety a služby
            </a>
            <div class="bg-white dropdown-menu" [class.show]="servicesDopdown.isOpen" role="menu" aria-labelledby="navbarServices">
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px; background: #CBD6FA; color: #000000"
                 onmouseover="this.style='font-size: 13px; background: #b4c3ff; color: #000000';"
                 onmouseout="this.style='font-size: 13px; background: #CBD6FA; color: #000000';"
                 routerLink="/services/catalogs"
                 (click)="closeNavBar(); scrollTop()">
                Katalógy
              </a>
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px"
                 routerLink="/services/promotional_items_and_textiles"
                 (click)="closeNavBar(); scrollTop()">
                Reklamné predmety a textil
              </a>
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px"
                 routerLink="/services/prints_and_stickers"
                 (click)="closeNavBar(); scrollTop()">
                Tlače a polepy
              </a>
              <a class="dropdown-item menuitem" href="#" style="font-size: 13px"
                 routerLink="/services/special_realizations_and_graphics"
                 (click)="closeNavBar(); scrollTop()">
                Špeciálne realizácie a grafika
              </a>
            </div>
          </li>
          <li #contactsDopdown="bs-dropdown" dropdown class="nav-item dropdown drop-pointer">
            <a dropdownToggle class="nav-link dropdown-toggle" id="navbarContacts"
               role="button" style="font-size: 13px" [class.text-white]="!isScrolled"
               aria-haspopup="true" aria-expanded="false"
               (click)="productsDopdown.hide(); servicesDopdown.hide()">
              Kontakty
            </a>
            <div class="bg-white dropdown-menu" [class.show]="contactsDopdown.isOpen" role="menu" aria-labelledby="navbarContacts">
              <a class="dropdown-item menuitem" href="#"
                 style="font-size: 13px; background: #CBD6FA; color: #000000"
                 onmouseover="this.style='font-size: 13px; background: #b4c3ff; color: #000000';"
                 onmouseout="this.style='font-size: 13px; background: #CBD6FA; color: #000000';"
                 routerLink="/contacts"
                 fragment="kontakt"
                 (click)="closeNavBar()">
                Kontaktný formulár
              </a>
              <a class="dropdown-item menuitem" style="font-size: 13px" href="#" id="t1"
                 routerLink="/contacts"
                 fragment="vedenie"
                 (click)="closeNavBar()">
                Vedenie spoločnosti
              </a>
              <a class="dropdown-item menuitem" style="font-size: 13px" href="#" id="t2"
                 routerLink="/contacts"
                 fragment="obchod"
                 (click)="closeNavBar()">
                Obchod
              </a>
              <a class="dropdown-item menuitem" style="font-size: 13px" href="#" id="t3"
                 routerLink="/contacts"
                 fragment="sluzby"
                 (click)="closeNavBar()">
                Služby
              </a>
              <a class="dropdown-item menuitem" style="font-size: 13px" href="#" id="t4"
                 routerLink="/contacts"
                 fragment="legislativa"
                 (click)="closeNavBar()">
                Legislatíva
              </a>
              <a href="#" class="dropdown-item menuitem" style="font-size: 13px"
                 routerLink="/contacts"
                 fragment="logistika"
                 (click)="closeNavBar()">
                Logistika a distribúcia
              </a>
              <a href="#" class="dropdown-item menuitem" style="font-size: 13px"
                 routerLink="/contacts"
                 fragment="sekretariat&fakturacie"
                 (click)="closeNavBar()">
                Sekretariát a fakturácie
              </a>
            </div>
          </li>
          <li class="nav-item">
            <a href="#" id="blog" class="nav-link" [class.text-white]="!isScrolled" style="font-size: 13px"
               routerLink="/blog"
               (click)="closeNavBar()">Blog</a>
          </li>
          <li class="nav-item">
            <a href="#" id="ponuka" class="nav-link" [class.text-white]="!isScrolled" style="font-size: 13px"
               routerLink="/surface-offer"
               (click)="closeNavBar()">Ponuka plôch</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div id="surfaceButtonDiv" class="position-fixed surface-button surface-button-first" routerLink="/surface-offer">
    <div id="surfaceButton" class="btn btn-primary" style="height: 200px; width: 65px;">
      <p class="surface-button-text text-white" style="display: flex; flex-direction: column; align-items: center"><span>Ponuka</span><span>reklamných plôch</span></p>
    </div>
  </div>
  <div id="promoButtonDiv" class="position-fixed surface-button surface-button-second" routerLink="/services/promotional_items_and_textiles">
    <div id="promoButton" class="btn btn-primary" style="height: 200px; width: 65px;">
      <p class="surface-button-text text-white" style="display: flex; flex-direction: column; align-items: center"><span>Reklamné predmety</span><span>a služby</span></p>
    </div>
  </div>
  <div id="promoButtonDiv2" class="position-fixed surface-button surface-button-still surface-button-third" (click)="openCookiesEditModal()">
    <div id="promoButton2" class="btn btn-primary" style="height: 100px; width: 65px;">
      <p class="surface-button-text-cookies text-white" style="display: flex; flex-direction: column; align-items: center"><span><img class="cookies-surface-image" src="assets/photos/cookies.png" alt="cookies">
    </span></p>
    </div>
  </div>

</ng-container>

